<template>
    <div style="width: 100%;height: 100%" class="flex-center">
        <el-result icon="warning" title="请下载大工程师进行体验" :subTitle="subTitle">
            <template slot="extra">
                <el-button type="primary" size="medium">下载大工程师</el-button>
            </template>
        </el-result>
    </div>
</template>

<script>
import {getUrlParam} from '@/utils/utils'

export default{
    data() {
        return {
            subTitle: getUrlParam('subtitle') || '警告提示',
        }
    },
    mounted() {
        
    },
}
</script>
